import type { ButtonProps } from '@hover/blueprint';
import { iconShare } from '@hover/icons';
import React from 'react';

import type { AiOrSampleDisplayImage } from 'src/modules/homeownerApp/types';
import { isAiDisplay } from 'src/modules/homeownerApp/types';
import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { buttonPressed } from 'src/shared/telemetry';

import { useHomeownerAppContext, useShareGeneratedImage } from '../../hooks';

export interface ShareButtonProps extends Omit<ButtonProps, 'icon' | 'label'> {
  aiDisplayImage: AiOrSampleDisplayImage;
}

export const ShareButton = ({ aiDisplayImage, ...props }: ShareButtonProps) => {
  const { trackingData } = useHomeownerAppContext();
  const share = useShareGeneratedImage({
    image: aiDisplayImage.aiGeneratedImage,
  });
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const handleShareClick: ButtonProps['onClick'] = event => {
    event.stopPropagation();

    buttonPressed({
      ...trackingData,
      track_id: 'share-button',
      button_text: 'share-icon',
      ai_generated_image_id: isAiDisplay(aiDisplayImage)
        ? aiDisplayImage.aiGeneratedImage.id
        : undefined,
      ai_display_image_id: isAiDisplay(aiDisplayImage)
        ? aiDisplayImage.id
        : undefined,
    });

    share();
  };

  return (
    <Button
      icon={iconShare}
      label={t('thumbnailEngagementButtons.share')}
      onClick={handleShareClick}
      {...props}
    />
  );
};
